// What an Incoterm says, read-only beside it (TX-US-0043, AC2): where the risk passes to the buyer
// and where the seller's costs end, from the Incoterm Reference sheet the BDs sent.

export default function IncotermFacts({ term }) {
  if (!term) return null;
  return (
    <dl className="incoterm-facts">
      <dt>Risk passes</dt>
      <dd>{term.risk_passes}</dd>
      <dt>Seller's costs end</dt>
      <dd>{term.costs_end}</dd>
    </dl>
  );
}
